import React from "react";
import { useHistory } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Fab from "@mui/material/Fab";
import FilterListIcon from "@mui/icons-material/FilterList";
import Table from "react-bootstrap/Table";
import Grid from "@mui/material/Grid";
import { Tooltip, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

import CharacterStance from "./CharacterStance";

import Bulwark from "../img/propertyIcons/bulwark.png";
import Bash from "../img/propertyIcons/bash.png";
import FullBlock from "../img/propertyIcons/fullBlock.png";
import Pins from "../img/propertyIcons/pins.png";
import Knockdown from "../img/propertyIcons/knockdown.png";
import Stun from "../img/propertyIcons/stun.png";
import SupBlock from "../img/propertyIcons/supBlock.png";
import Trap from "../img/propertyIcons/trap.png";
import Unblockable from "../img/propertyIcons/unblockable.png";
import Undodgeable from "../img/propertyIcons/undodgeable.png";
import Uninterruptable from "../img/propertyIcons/uninterruptible.png";
import Wallsplat from "../img/propertyIcons/wallsplat.png";
import Bleed from "../img/propertyIcons/bleed.png";
import Deflect from "../img/propertyIcons/deflect.png";
import Parry from "../img/propertyIcons/parry.png";
import SuperiorBlockDodge from "../img/propertyIcons/dodgecounter.png";
import SoftFeints from "../img/propertyIcons/softFeintable.png";
import Enhanced from "../img/propertyIcons/enhanced.png";
import PKBleed from "../img/propertyIcons/pkbleed.png";
import consumesSouls from "../img/propertyIcons/consumesSouls.png";
import soulAttack from "../img/propertyIcons/soulAttack.png";
import Shield from "../img/propertyIcons/shield.png";

import "./CharacterAttacks.css";

const PropertyTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: "0.8rem",
  },
});

// Reusable PropertyIcon component
const PropertyIcon = ({ property, icon, history, isInput }) => {
  const handleClick = () => {
    if (isInput) {
      history.push(`/attacks?input=${encodeURIComponent(property)}`);
    } else {
      history.push(`/attacks?property=${encodeURIComponent(property)}`);
    }
  };
  return (
    <PropertyTooltip 
      title={property} 
      arrow 
      placement="top" 
      PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, -14], } }] }}
    >
      <img
        className="propertyImage"
        src={icon}
        alt={property}
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      />
    </PropertyTooltip>
  );
};

const CharacterAttacks = ({ characterAttacks, faction, characterId }) => {
  const [headerDetails, setHeaderDetails] = React.useState({
    "Running Attacks": true,
    "Confirmed Attacks": true,
    "Zone Attacks": true,
    "Basic Attacks": true,
    Ripostes: true,
    "Forward Dodge Attacks": true,
    "Side Dodge Attacks": true,
    "Chain Bashes": true,
    "Neutral Bashes": true,
    "Special Moves": true,
    "Stance Attacks": true,
  });

  const [characterStance, setCharacterStance] = React.useState();
  const [isFilterOpen, setFilterOpen] = React.useState(false);
  const [open, setOpen] = React.useState({
    speed: true,
    damage: true,
    stamina: true,
    specialproperties: true,
    direction: true,
    input: true,
    hitstun: true,
    recoveries: false,
    notes: false,
  });
  const [isNotesOpened, setNotesOpened] = React.useState("");
  const history = useHistory();

  React.useEffect(() => {
    getCharacterStance();
  }, []);

  const getCharacterStance = () => {
    fetch(`https://forhonorinfohub.com/api/CharacterStance?characterId=${characterId}`)
      .then((response) => response.json())
      .then((myJson) => setCharacterStance(myJson[0]));
  };

  const handleClick = (attack_name) => {
    setOpen((prev) => ({ ...prev, [attack_name]: !prev[attack_name] }));
  };

  const handleNotes = (id) => {
    setNotesOpened((prev) =>
      prev?.includes(id) ? prev.replace(id, "-") : prev + id
    );
  };

  const handleHeader = (attack_name) => {
    setHeaderDetails((prev) => ({ ...prev, [attack_name]: !prev[attack_name] }));
  };

  if (!characterAttacks || characterAttacks.length < 1) return null;

  const fabStyle = { position: "fixed", bottom: "3%", right: "2%" };

  // Mapping special properties to icons
  const propertyMap = [
    { name: "Bulwark Counter", icon: Bulwark },
    { name: "All Guard", icon: FullBlock },
    { name: "Pins", icon: Pins },
    { name: "Knocksdown", icon: Knockdown },
    { name: "Stuns", icon: Stun },
    { name: "Superior Block", icon: SupBlock },
    { name: "Trap", icon: Trap },
    { name: "Unblockable", icon: Unblockable },
    { name: "Bash", icon: Bash },
    { name: "Undodgeable", icon: Undodgeable },
    { name: "Hyperarmor", icon: Uninterruptable },
    { name: "Wallsplats", icon: Wallsplat },
    { name: "Bleeds", icon: Bleed },
    { name: "Soft-Feintable", icon: SoftFeints },
    { name: "Superior Block Dodge", icon: SuperiorBlockDodge },
    { name: "Parry", icon: Parry },
    { name: "Deflect", icon: Deflect },
    { name: "Enhanced", icon: Enhanced },
    { name: "Exsanguis Laceratrix", icon: PKBleed },
    { name: "Soul Attack", icon:soulAttack},
    { name: "Consumes Souls", icon:consumesSouls},
    { name: "Hyperarmor in Onslaught", icon:Uninterruptable},
    { name: "Unblockable in Ultimate", icon:Unblockable},
    { name: "Gives Shield in Onslaught", icon:Shield}
  ];


  return (
    <div>
      <Fab style={fabStyle} onClick={() => setFilterOpen(!isFilterOpen)}>
        <FilterListIcon />
      </Fab>

      {isFilterOpen && (
        <div className="filters">
          {["damage", "speed", "stamina", "input", "direction", "hitstun", "specialproperties", "recoveries", "misc"].map((field) => (
            <ListItemButton key={field} onClick={() => handleClick(field)}>
              <ListItemText primary={field.charAt(0).toUpperCase() + field.slice(1)} />
              {open[field] ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
            </ListItemButton>
          ))}
        </div>
      )}

      {Object.keys(characterAttacks).map((key, index1) => (
        <div key={index1}>
          {key === "Stance Attacks" && (
            <CharacterStance CharacterStance={characterStance} faction={faction} />
          )}

          {characterAttacks[key] && (
            <div id={key}>
              <header className={faction}>
                <h1 className="text-center">{key}</h1>
                <div onClick={() => handleHeader(key)} style={{ cursor: "pointer" }}>
                  {headerDetails[key] ? <ExpandLess /> : <ExpandMore />}
                </div>
              </header>

              <Grid container direction="row" justifyContent="center" >
                {headerDetails[key] &&
                  characterAttacks[key]?.map((item, index2) => {
                    const inputMethodProperties = ["Parry", "Deflect", "Superior Block Dodge"];

                    const specialProps = item.special_properties
                    ?.split(",")
                    .map((s) => s.trim()) || [];

                    const inputMethod = item.input_method || "";

                    const properties = propertyMap
                    .map((p) => {
                      const propName = p.name;
                  
                      if (specialProps.includes(propName)) return { ...p, isInput: false };
                  
                      if (
                        inputMethodProperties.includes(propName) &&
                        inputMethod.includes(propName) // now safe because empty string fallback
                      ) {
                        return { ...p, isInput: true };
                      }
                  
                      return null;
                    })
                    .filter(Boolean);
                
                    // You must return the JSX here
                    return (
                    <div className="attack" key={index2}>
                      <List
                        sx={{ minWidth: 300, bgcolor: "background.paper", boxShadow: "3px 3px 3px 3px grey" }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                          <ListSubheader component="div" id="nested-list-subheader" disableSticky style={{ display: "flex", alignItems: "center" }}>
                            {properties.length > 0 && (
                              <div className="propertyIcons">
                                {properties.map((p) => (
                                  <PropertyIcon
                                    key={p.name}
                                    property={p.name}
                                    icon={p.icon}
                                    history={history}
                                    isInput={p.isInput}
                                  />
                                ))}
                              </div>
                            )}
                            <div style={{ lineHeight: "initial" }}>{item.attack_name}</div>
                          </ListSubheader>
                        }
                      >
                      {item.damage && (
                        <Collapse in={open["damage"]} timeout="auto" unmountOnExit>
                          <ListItemButton className="redField">
                            <ListItemText primary="Damage" />
                            {item.damage || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item.bleed_damage && (
                        <Collapse in={open["damage"]} timeout="auto" unmountOnExit>
                          <ListItemButton className="redField">
                            <ListItemText primary="Bleed Damage" />
                            {item.bleed_damage || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item.stamina_damage && (
                        <Collapse in={open["damage"]} timeout="auto" unmountOnExit>
                          <ListItemButton className="redField">
                            <ListItemText primary="Stamina Damage" />
                            {item.stamina_damage || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item.attack_speed && (
                        <Collapse in={open["speed"]} timeout="auto" unmountOnExit>
                          <ListItemButton className="blueField">
                            <ListItemText primary="Speed (ms)" />
                            {item.attack_speed || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item.stamina_usage && (
                        <Collapse in={open["stamina"]} timeout="auto" unmountOnExit>
                          <ListItemButton className="greenField">
                            <ListItemText primary="Stamina Usage" />
                            {item.stamina_usage || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item.input_method && (
                        <Collapse in={open["input"]} timeout="auto" unmountOnExit>
                          <ListItemButton>
                            <ListItemText primary="Input Method" />
                            <div className="CardText">{item.input_method || "N/A"}</div>
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item.input_window && (
                        <Collapse in={open["input"]} timeout="auto" unmountOnExit>
                          <ListItemButton>
                            <ListItemText primary="Input Window (ms)" />
                            {item.input_window || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item.direction && (
                        <Collapse in={open["direction"]} timeout="auto" unmountOnExit>
                          <ListItemButton>
                            <ListItemText primary="Direction" />
                            {item.direction || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item?.hitstun_category && (
                        <Collapse in={open["hitstun"]} timeout="auto" unmountOnExit>
                          <ListItemButton>
                            <ListItemText primary="Hitstun" />
                            {item?.hitstun_category || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item.special_properties && (
                        <Collapse in={open["specialproperties"]} timeout="auto" unmountOnExit>
                          <ListItemButton>
                            <ListItemText primary="Properties" />
                            <div className="CardText">{item.special_properties || "N/A"}</div>
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item?.hyperarmor_startup && (
                        <Collapse in={open["specialproperties"]} timeout="auto" unmountOnExit>
                          <ListItemButton>
                            <ListItemText primary="Hyperarmor Startup (ms)" />
                            {item?.hyperarmor_startup || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item?.superior_block_window && (
                        <Collapse in={open["specialproperties"]} timeout="auto" unmountOnExit>
                          <ListItemButton>
                            <ListItemText primary="Superior Block Window (ms)" />
                            {item?.superior_block_window || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item?.pin_duration && (
                        <Collapse in={open["specialproperties"]} timeout="auto" unmountOnExit>
                          <ListItemButton>
                            <ListItemText primary="Pin Duration (ms)" />
                            {item?.pin_duration || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item?.iframe_window && (
                        <Collapse in={open["specialproperties"]} timeout="auto" unmountOnExit>
                          <ListItemButton>
                            <ListItemText primary="I-Frame Duration (ms)" />
                            {item?.iframe_window || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      {item.earliest_dodge && (
                        <Collapse in={open["misc"]} timeout="auto" unmountOnExit>
                          <ListItemButton>
                            <ListItemText primary="Earliest Dodge (ms)" />
                            {item.earliest_dodge || "N/A"}
                          </ListItemButton>
                        </Collapse>
                      )}

                      <Collapse in={open["recoveries"]} timeout="auto" unmountOnExit>
                        <ListItemButton>
                          <Table className="text-center" style={{ backgroundColor: "rgb(55,55,55)" }} striped bordered responsive="sm">
                            <tbody>
                              <tr>
                                <td colSpan={5}>Recoveries (ms)</td>
                              </tr>
                              <tr className="align-middle">
                                <td> </td>
                                <td>Hit</td>
                                <td>Miss</td>
                                <td>Block</td>
                                <td>Superior Block</td>
                              </tr>
                              <tr className="align-middle">
                                <td>Base</td>
                                <td>{item.hit_recovery_base || "Soon™"}</td>
                                <td>{item.miss_recovery_base || "Soon™"}</td>
                                <td>{item.block_recovery_base || "Soon™"}</td>
                                <td>{item.superior_block_recovery_base || "Soon™"}</td>
                              </tr>
                              <tr className="align-middle">
                                <td>Guard Swap</td>
                                <td>{item.hit_block_recovery_guardswap || "Soon™"}</td>
                                <td>{item.miss_recovery_guardswap || "Soon™"}</td>
                                <td>{item.block_recovery_guardswap || "Soon™"}</td>
                                <td>{item.superior_block_recovery_guardswap || "Soon™"}</td>
                              </tr>
                            </tbody>
                          </Table>
                        </ListItemButton>
                      </Collapse>

                      {item.notes && (
                        <ListItemButton
                          className="ListItemNotes"
                          sx={{ backgroundColor: "lightgrey" }}
                          onClick={() => handleNotes(item.ID)}
                        >
                          <ListItemText primary="Notes" />
                          {isNotesOpened?.includes(item.ID) ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                      )}
                      {item.notes && (
                        <Collapse in={isNotesOpened?.includes(item.ID)} timeout="auto" unmountOnExit>
                          <ListItemButton>{item.notes || "N/A"}</ListItemButton>
                        </Collapse>
                      )}
                      </List>
                    </div>
                    );
                  })}
              </Grid>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CharacterAttacks;